var Vendd = (function (Vendd) {
    'use strict';

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SearchForProducts, Vendd.RequestOffer, function (envelope) {

        var options = {
            url: 'api/RequestOffer/SearchForProducts?searchterm=' + envelope.message.data.searchTerm,
            method: 'GET',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SearchForProductsSuccess(response));
        }

        function onFailure(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SearchForProductsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.AddOfferProducts, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/AddOfferProducts',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddOfferProductsSuccess(response.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddOfferProductsFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.GetPendingRequestsOffer, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/GetPendingRequestsOffer?offerid=' + envelope.message.data.offerid + '&pageSize=' + envelope.message.data.pageSize + '&pageNum=' +envelope.message.data.pageNum,
            data: envelope.message.data,
            method: 'GET',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.GetPendingRequestsOfferSuccess(response.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.GetPendingRequestsOfferFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.UpdateRequestOfferProducts, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/UpdateRequestOfferProducts',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.UpdateRequestOfferProductsSuccess(response.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.UpdateRequestOfferProductsFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.DeleteRequestOffer, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/DeleteRequestOffer',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.DeleteRequestOfferSuccess(response.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.DeleteRequestOfferFailure(response));
        };

        Vendd.Service.call(options);

        return;
    })

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SubmitRequestOffer, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/Submit',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SubmitRequestOfferSuccess(response.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SubmitRequestOfferFailure(response));
        };

        Vendd.Service.call(options);

        return;
    })

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.ImportRequestOfferExcel, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/ImportRequestOfferExcel',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ImportRequestOfferExcelSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ImportRequestOfferExcelFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    return Vendd;

})(Vendd || {});